import { useTranslation } from 'react-i18next';
import OInput from '../../../UI/FormControls/OInput';
import OAutocomplete from '../../../UI/MuiAutocomplete';
import MyButton from '../../../UI/myButton/MyButton';
import { useState } from 'react';
import useHttp from '../../../../hooks/use-http';
import { urls } from '../api/urls';
import toast from 'react-hot-toast';

const Inputs = ({
  formValues,
  setFormValues,
  kategorijeData,
  erpId,
  setErpId,
}) => {
  const { t, i18n } = useTranslation();
  // const [erpId, setErpId] = useState('');
  const { getData } = useHttp('');

  const handleChange = (item) => {
    if (typeof formValues[item.target.name] === 'boolean') {
      setFormValues((curr) => {
        return { ...curr, [item.target.name]: item.target.checked };
      });
    } else {
      setFormValues((curr) => {
        return { ...curr, [item.target.name]: item.target.value };
      });
    }
  };

  const handleChangeErpId = (e) => {
    setErpId(e.target.value);
  };

  const handleClickKategorije = (item) => {
    setFormValues((curr) => {
      return {
        ...curr,
        idKategorijeZaposlenog: item.id,
        nazivKategorijeZaposlenog: item.vrednost,
      };
    });
  };
  const handleSatnice = async () => {
    if (erpId < 1 || erpId === '' || erpId === null || erpId === undefined) {
      toast.error('Potrebno je popuniti polje ERP ID.');
      return;
    }
    const config = {
      method: 'POST',
      url: urls.GET_SATNICE_ERP,
      data: { id: +erpId },
    };

    const result = await getData(config);
    if (result.id) {
      setFormValues((curr) => {
        return {
          ...curr,
          ime: result.ime,
          prezime: result.prezime,
          email: result.email,
          brutoCena: result.cena,
          inoBrutoCena: result.cena,
          brutoCenaPrekovremena: result.prekovremeno,
        };
      });
      return;
    }
    if (result?.response?.data === 'Sequence contains no elements') {
      toast.error('Nije pronađen korisnik za uneti ID');
    }
  };
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: '2px',
        marginBottom: '10px',
      }}
    >
      <OInput
        label={`${t('firstName')} *`}
        name="ime"
        value={formValues.ime}
        handleChange={handleChange}
        touched={formValues.touchedIme}
        setTouched={() => {
          setFormValues((curr) => {
            return { ...curr, touchedIme: true };
          });
        }}
        errorMessage={`${t('firstName')} ${t('isRequired')}`}
        // style={{ width: '100%' }}
      />
      <OInput
        label={`${t('lastName')} *`}
        name="prezime"
        value={formValues.prezime}
        handleChange={handleChange}
        touched={formValues.touchedPrezime}
        setTouched={() => {
          setFormValues((curr) => {
            return { ...curr, touchedPrezime: true };
          });
        }}
        errorMessage={`${t('lastName')} ${t('isRequired')}`}
        // style={{ width: '100%' }}
      />
      <OInput
        label="Email"
        name="email"
        value={formValues.email}
        handleChange={handleChange}
        touched={formValues.touchedEmail}
        setTouched={() => {
          setFormValues((curr) => {
            return { ...curr, touchedEmail: true };
          });
        }}
        errorMessage={`Email ${t('isRequired')}`}
        // style={{ width: '100%' }}
      />
      <OInput
        type="number"
        label={`${t('grossPrice')} *`}
        name="brutoCena"
        value={formValues.brutoCena}
        handleChange={handleChange}
        touched={formValues.touchedBrutoCena}
        setTouched={() => {
          setFormValues((curr) => {
            return { ...curr, touchedBrutoCena: true };
          });
        }}
        errorMessage={`${t('grossPrice')} ${t('isRequired')}`}

        // style={{ width: '100%' }}
      />
      <OInput
        type="number"
        label={t('inoGrossPrice')}
        name="inoBrutoCena"
        value={formValues.inoBrutoCena}
        handleChange={handleChange}
      />
      <OInput
        type="number"
        label={t('grossPriceOvertime')}
        name="brutoCenaPrekovremena"
        value={formValues.brutoCenaPrekovremena}
        handleChange={handleChange}
      />
      <OAutocomplete
        data={kategorijeData}
        value={formValues.nazivKategorijeZaposlenog}
        handleClick={handleClickKategorije}
        label={t('category')}
        style={{ width: '200px' }}
      />
      <OInput
        type="number"
        label="ERP ID"
        name="inoBrutoCena"
        value={erpId}
        handleChange={handleChangeErpId}
        style={{ width: '65px' }}
      />
      <MyButton
        label={t('loadHourlyRates')}
        icon="fas fa-user-clock"
        onClick={handleSatnice}
      />
    </div>
  );
};

export default Inputs;
